import getInboxRuleRequest from 'owa-service/lib/factory/getInboxRuleRequest';
import getInboxRuleOperation from 'owa-service/lib/operation/getInboxRuleOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * Helper method that creates the GetInboxRuleRequest body
 * @return GetInboxRuleRequest
 */
function createRequestBody() {
    return getInboxRuleRequest({ Header: getJsonRequestHeader() });
}
/**
 * Get inbox rules service
 * @return the GetInboxRuleResponse
 */
export default function getInboxRulesService() {
    var requestBody = createRequestBody();
    return getInboxRuleOperation(requestBody);
}
//# sourceMappingURL=getInboxRulesService.js.map